/**
 * @generated SignedSource<<5ada5e0bd6a526fc4b92a16bfae01058>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstname",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MyAccountTopQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MyAccountTopQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "40b64201370f547cd52176d4f58996c2",
    "id": null,
    "metadata": {},
    "name": "MyAccountTopQuery",
    "operationKind": "query",
    "text": "query MyAccountTopQuery {\n  user {\n    id\n    email\n    firstname\n  }\n}\n"
  }
};
})();

node.hash = "e04726fd529f7c6ffcdf0747a5bc03e9";

module.exports = node;
